// disable auto-story

import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface BladeProps {
  children: ReactNode;
  visible?: boolean;
  className?: string;
  rollup?: boolean;
}

/**
 * Represents a dropdown blade with a white background and drop shadow.
 */
function Blade({ children, visible, className, rollup, ...rest }: BladeProps) {
  const classes = twMerge(
    'absolute top-full mt-2 items-baseline transition-all z-10 scale-y-100 opacity-100 origin-top',
    !visible && 'invisible opacity-0',
    !visible && rollup && 'scale-y-50',
    className
  );
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export default Blade;
